import { device } from '@game-studio/arcade-base';
import { PRECISION, settings } from 'pixi.js-legacy';

const LOW_RATING: number = 1;
const STANDARD_RATING: number = Math.min(window.devicePixelRatio, 2);
const HIGH_RATING: number = Math.min(window.devicePixelRatio, 3);

const IOS_STANDARD: number = 10;
const ANDROID_STANDARD: number = 11;

const IOS_LOW: number = 9;
const ANDROID_LOW: number = 6;

interface IDeviceBLValue {
    vendor: string;
    modelORprefix: string;
}

export default class Rating {
    public static lastCheckedRating: number = 1;
    public static performanceVersion: boolean = false;

    public static getRating(): number {
        let rating: number = STANDARD_RATING;

        const OS = device.info.operatingSystem;

        // CHECK STANDARD
        if (OS.name === 'iOS') {
            settings.PRECISION_FRAGMENT = PRECISION.HIGH;
            rating = OS.version.major < IOS_STANDARD ? STANDARD_RATING : HIGH_RATING;
        } else if (OS.name === 'Android') {
            rating = OS.version.major < ANDROID_STANDARD ? STANDARD_RATING : HIGH_RATING;
        }

        // CHECK LOW
        if (OS.name === 'iOS') {
            rating = OS.version.major < IOS_LOW ? LOW_RATING : rating;
        } else if (OS.name === 'Android') {
            rating = OS.version.major < ANDROID_LOW ? LOW_RATING : rating;
        }

        // MISC CHECK
        if (device.type.isDesktop) {
            rating = STANDARD_RATING;
        }

        // force strong optimisation
        if (this.isBlackListed()) {
            this.performanceVersion = true;
            rating = rating * 0.85;
        }

        this.lastCheckedRating = rating;
        return rating;
    }

    public static getSoundFormat(): string {
        let format: string = 'mp3';

        const OS = device.info.operatingSystem;

        // CHECK LOW
        if (OS.name === 'iOS') {
            format = OS.version.major < IOS_STANDARD ? 'mp3' : 'ogg';
        } else if (OS.name === 'Android') {
            format = OS.version.major < ANDROID_STANDARD ? 'mp3' : 'ogg';
        }
        // MISC CHECK
        if (device.type.isDesktop) {
            format = 'ogg';
        }

        // WINDOWS CHECK
        format = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0 ? 'mp3' : format;

        format = device.info.browser.name === 'Safari' ? 'mp3' : format;

        return format;
    }

    private static isBlackListed(): boolean {
        const blackList: IDeviceBLValue[] = [
            { vendor: 'Samsung', modelORprefix: 'SM-J' },
            { vendor: 'Samsung', modelORprefix: 'GT-I95' }
        ];

        const deviceModel: string | undefined = device.model.model;
        let isBlackListed: boolean = false;

        if (deviceModel !== undefined) {
            for (let $BLindex: number = 0; $BLindex < blackList.length; $BLindex++) {
                if (blackList[$BLindex].vendor === device.model.vendor) {
                    if (deviceModel.indexOf(blackList[$BLindex].modelORprefix) !== -1) {
                        isBlackListed = true;
                    }
                }
            }
        }
        return isBlackListed;
    }
}
